module.exports = __webpack_public_path__ + "static/media/dx.3a46fc37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dx.jpg
// module id = 378
// module chunks = 0